import {Injectable} from '@angular/core'
import {Meta, MetaDefinition} from "@angular/platform-browser";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  public meta$: BehaviorSubject<HTMLMetaElement | null> = new BehaviorSubject<HTMLMetaElement | null>(null)

  public setMetaTag(key: string, value: string): void {
    let metaTag = this.meta.getTag(`name=${key}`);

    if(!metaTag) {
      const newMetaTag: MetaDefinition = {
        name: key,
        content: value
      }
      metaTag = this.meta.addTag(newMetaTag);
    } else {
      metaTag.content = value;
    }

    this.meta$.next(metaTag);
  }

  public constructor(
    private readonly meta: Meta
  ) {}
}
